import store from 'store'

// 로컬 사용자 키(app.user.*) 일괄 제거 — 무의존 유틸 (redux/api/i18n import 금지, extensionBridge 패턴).
// landing.removeAllAppUserKeys(TOTP 지문·메모 초안 정리 포함 chokepoint)의 localStorage 순회부이며,
// 로그인 중 차단 처리(pUtils.login)도 직접 사용한다 — pUtils → landing import는 순환(landing이
// pUtils를 import)이라 분리. 로그인 도중 차단은 신규 세션 미성립 상태라 키 정리만으로 충분.
export const removeLocalAppUserKeys = () => {
  if (typeof localStorage !== 'undefined') {
    const keysToRemove = []
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i)
      // `envParem.common_auth_changePW` 는 접두어가 달라 app.user. 조건에 안 걸린다.
      // 메모리 이관(설계 §3.3) 후 새 코드는 이 키를 쓰지 않으므로, 정리하지 않으면
      // 기존 사용자 localStorage 에 **영구 잔존**한다. 호출처 4곳이 이 chokepoint 를
      // 경유하므로 여기 한 곳만 고치면 자동 승계된다.
      if (key && (key.startsWith('app.user.') || key === 'envParem.common_auth_changePW')) {
        keysToRemove.push(key)
      }
    }
    keysToRemove.forEach((key) => store.remove(key))
  }
}

export default removeLocalAppUserKeys
